
export default class UrlManager {
  constructor(router) {
    this.router = router;
  }

  updateUrl({ page, eventId = null, date = null, categories = null }) {
    if (!['', 'calendar', 'map'].includes(page)) {
      console.warn('❌ Неподдерживаемая главная страница:', page);
      return;
    }

    let path = `/${page}`;
    const hasFilters = !!date || !!categories;
    const hasEvent = !!eventId;

    if (hasFilters) {
      path += '/events';
    }

    if (hasEvent) {
      path += `/event/${eventId}`;
    }

    let query = {};
    if (hasFilters) {
      if (date) query.date = date;
      if (categories) query.categories = categories;
    }

    path = path.replace(/\/\//g, '/');

    this.router.replace({ path, query });
  }

  getInfoUrl() {
    const route = this.router.currentRoute.value;
    const fullPath = route.path;
    const query = route.query;
  
    const segments = fullPath.split('/').filter(Boolean);
  
    let page = '';
    let hasEvents = false;
    let eventId = null;
  
    if (segments.length > 0) {
      const first = segments[0];
      if (['map', 'calendar'].includes(first)) {
        page = first;
      }
    }
  
    if (segments.includes('events')) {
      hasEvents = true;
    }
  
    const eventIndex = segments.indexOf('event');
    if (eventIndex !== -1 && segments.length > eventIndex + 1) {
      eventId = segments[eventIndex + 1];
    }
  
    const date = query.date || null;
    const categoriesEncoded = query.categories || null;
  
    return {
      page,
      hasEvents,
      eventId,
      date,
      categoriesEncoded
    };
  }
  
  
  
}
